import CanadaChoropleth from './components/CanadaChoropleth';

function App() {
  return (
    <div className="App">
      <CanadaChoropleth />
    </div>
  );
}

export default App;
